import React from 'react';
import styles from './ClubTabs.module.css';

export default function ClubTabs({ tabs, activeTab, onTabChange }) {
    if (!tabs || tabs.length === 0) return null;

    return (
        <nav className={styles.tabs} aria-label="Club sections">
            {tabs.map((tab, index) => (
                <button 
                    className={activeTab === index ? styles.activeTab : ''} 
                    type="button" 
                    key={tab}
                    onClick={() => {
                        if (onTabChange) {
                            onTabChange(index, tab);
                        }
                    }}
                >
                    {tab}
                </button>
            ))}
        </nav>
    );
}
